import { yup } from 'form';

import { baseSalesOrderFormSchema } from './baseSalesOrderSchema';

export const createSalesOrderSchema = baseSalesOrderFormSchema.shape({
  collection_address_country: yup.string().required(),
});
